(function() {
	'use strict';
	var $ = avm.require('jquery'),
		platformSwitcher = avm.require('avast.web.platformSwitcher'),
		$document = $(document),
		$window = $(window),
		$entry = $('.js-entry'),
		$tab = $('.js-tab'),
		$more = $('.js-more'),
		$close = $('.js-close'),
		$tooltip = $('.js-tooltip'),
		$expandPunch = $('.js-expand-punch'),
		$carousel = $('.js-carousel');

	platformSwitcher.init();


// Info box panels
	// adds .expanded to closest .js-info-box
	$more.on('click', function() {
		var $target = $(this).closest('.js-info-box');

		if ($target.hasClass('expand')) {
			$('html, body').animate({
				scrollTop: $target.offset().top - 405
			}, 500);
		}

		$target.toggleClass('expand');
	});

	// removes .expanded when clicking close
	$close.on('click', function() {
		var $target = $(this).closest('.js-info-box');
		$target.removeClass('expand');
	});

// Server map tooltip vertical position calculated according to its height
	$entry.on('mouseenter', function() {
		var $target = $(this).next('.tooltip'),
			height = $target.outerHeight();
		$target.css({
			top: -height - 15 + 'px'
		}).show();
	});

	$entry.on('mouseleave', function() {
		$tooltip.hide();
	});
 
// Tabs switcher
	$tab.on('mouseenter', function() {
		var $self = $(this),
			$selfCarousel = $self.closest('.js-carousel'),
			$selfSections = $selfCarousel.find('.js-tab-section'),
			$selfTabs = $selfCarousel.find('.js-tab'),
			tabIndex = $selfTabs.index($self);

		$selfTabs.removeClass('active');
		$selfSections.removeClass('active');
		$selfTabs.eq(tabIndex).addClass('active');
		$selfSections.eq(tabIndex).addClass('active');
	});

// Equalize heights of tabs sections
	function equalizeTabsSections() {
		var getMaxHeight = function(array) {
			return Math.max.apply(Math, array);
		};

		$carousel.each(function() {
			var $self = $(this),
				$selfTabSections = $self.find('.js-tab-section'),
				heights = [];

			// Collect heights of tabs section for current carousel
			$selfTabSections.each(function() {
				var $self = $(this);
				heights.push($self.height());
			});

			// Set heights of tabs section for current carousel
			$selfTabSections.each(function() {
				var $self = $(this);
				$self.height(getMaxHeight(heights));
			});
		});
	}

	$document.ready(function() {
		equalizeTabsSections();
	});
	$window.on('resize', function() {
		equalizeTabsSections();
	});

// Decorate links

	var decorate = avm.require('avast.web.linkDecorator'),
		unserializeUrl = avm.require('avast.url.unserialize'),
		params = unserializeUrl(window.location.href);

	for (var key in params) {
		decorate('.bi-cart-link', key);
	}
// /Decorate links
})();
